<template>
    <div class="dm-finish-account-setup-form">
		<h5 class="border-bottom fw-bold pb-3 mb-4">Password</h5>
		<SetPasswordForm
			:user_data="userData" />

		<h5 class="border-bottom fw-bold pb-3 mb-4">Preferences</h5>

		<CategoryPreferences
				v-for="category in categories" 
				:key="'category-' + category.id" 
				:category="category" 
				:preferences="userData.preferences" 
				@changesMade="hasChanges = true"/>

		<div class="text-center">
			<button 
				class="btn mt-3 mb-4 dm-btn-padding dm-view-as-pdf"
				:class="{ 'disabled' : !canSubmit }"
				:disabled="!canSubmit"
				@click="submit()">Update Password and Preferences</button>
		</div>

	</div>
</template>

<script>
import SetPasswordForm from '../user/partials/SetPasswordForm.vue';
import CategoryPreferences from '../../../shared/taxonomies/CategoryPreferences.vue';

export default {
	props: ['token'],
    components: { SetPasswordForm, CategoryPreferences },

	computed: {
		canSubmit() {
			if (this.userData.password.length < 8) return false;
			if (this.userData.password != this.userData.password_confirmation) return false;
			if (this.userData.preferences.categories.length == 0) return false;

			return true;
		}
	},

	data() {
		return {
			// editor: null,
			// hasChanges: false,
			categories: null,
			userData: {
				token: this.token,
				password: '',
				password_confirmation: '',
				preferences: {
					sub_categories: [],
					genres: [],
					categories: [],
				},
			}
		}
	},

	methods: {
		loadTaxonomiesGroupedByCategory() { // Used on the advanced directory filters as well
			var self = this;
			axios.get('/taxonomies-by-category').then(function (response) {
				self.categories = response.data;
			});
		},

		submit() {
			var self = this;
			
			axios.post('/finish-account-setup', this.userData)
				.then(function (response) {
					if (response && response.data && response.data.redirect_to)
						self.showUpdatedPopup(response.data.redirect_to);
				})
				.catch(function (error) {
					console.log(error);            
				});

		},

		showUpdatedPopup(redirectTo) {
			var self = this;
			this.$swal({
				text: 'Password and preferences updated',
				icon: "success",
			}).then(function () {
				self.redirectToEditorDashboard(redirectTo)
			});
		},

		redirectToEditorDashboard(redirectTo) {
			window.location.href = redirectTo;
		}
		
	},

	mounted() {
		this.loadTaxonomiesGroupedByCategory();
		// this.showUpdatedPopup('/test');
	}
}
</script>
